export default "function resetPassword(){}$(document).ready(function(){});";